export default () => ({
  expand: 0,
  toggle(index) {
    // Toggle logic: if clicked item is already expanded, collapse it (set to 0)
    if (this.expand == index) {
      this.expand = 0;
    } else {
      this.expand = index;
    }
  },
  isExpanded(index) {
    return this.expand == index;
  },
});
